import axiosClient from './axiosClient'

const prefixUrl = '/resource/'

const resourceApi = {
  getByCompanyId: (params) => {
    const url = '/resource/getByCompanyId'
    return axiosClient.get(url, { params })
  },
  getSynthetic: () => axiosClient.get(prefixUrl + 'synthetic'),
  doiSoat: (data) => {
    const url = prefixUrl + 'history/doi-soat'
    return axiosClient.post(url, {
      limit: 10,
      page: 0,
      order: [['createdAt', 'DESC']],
      ...data,
    })
  },
}
export default resourceApi
